export default __webpack_public_path__ + "static/media/login_pig.979b1451.png";